const publicPrefix = "";
export const PATHS = {
    public: {
        "Homepage": "/",
        "Become a PSO": publicPrefix + "/pso",
        "Current Common Formats": publicPrefix + "/common-formats",
        "Explore Common Format Data Elements": publicPrefix + "/common-formats/data-elements",
        // "Data Element Detail": publicPrefix + "/common-formats/data-elements",
        "Provide Feedback": publicPrefix + "/common-formats/feedback",
        // "Provide Feedback Target": publicPrefix + "/common-formats/feedback",
        "Retired Common Formats": publicPrefix + "/common-formats/retired-formats",
        "Community Pharmacy": publicPrefix + "/common-formats/community-pharmacy",
        "Diagnostic Safety": publicPrefix + "/common-formats/diagnostic-safety",
        "Hospital Version 1.2": publicPrefix + "/common-formats/hospital-1.2",
        "Hospital Version 2.0": publicPrefix + "/common-formats/hospital-2.0",
        "Nursing Home": publicPrefix + "/common-formats/nursing-home",
        "Surveillance - Hospital": publicPrefix + "/common-formats/surveillance-hospital",
        "Submit Data": publicPrefix + "/submit-data",
        "Learn from the Data": publicPrefix + "/analytics",
        "Get Help": publicPrefix + "/help",
        "Read Help Articles": publicPrefix + "/help/articles",
        "Join us for an Event": publicPrefix + "/help/joinus",
        "About PSOPPC": publicPrefix + "/about",
        "Search": publicPrefix + "/search",
        "Sign In": publicPrefix + "/sign-in",
        "Data Security": publicPrefix + "/privacy",
        "Terms of Use": publicPrefix + "/terms",
        "Accessibility": publicPrefix + "/accessibility",
        "Site Map": publicPrefix + "/site-map",
        "Privacy Policy": publicPrefix + "/policy",
        "PSOPPC Articles": publicPrefix + "/articles",
        "Article": publicPrefix + "/articles/:id",
        "Article With Slug": publicPrefix + "/articles/:id/:slug",
        "User Account Types": publicPrefix + "/account-types",
        //"Educational Briefs": publicPrefix + "/articles",
        "External Link Disclaimer": publicPrefix + "/disclaimer",
        "Download": "/download",
        "News & Updates": publicPrefix + "/news-updates",
        "Subscribe Verify": publicPrefix + "/subscribe/token/:token",
        "Unsubscribe Verify": publicPrefix + "/unsubscribe/token/:token",
        // "Common Formats Repository": publicPrefix + "/common-formats/repository",
        "Common Formats Repository": publicPrefix + "/common-formats/repository",

        "Data Element Detail": publicPrefix + "/common-formats/repository/detail/:verId/:deId",

        "TestPath": "/test",
        "Crumbs Test 1": "/test/crumbs1",
        "Crumbs Test 2": "/test/crumbs1/crumbstest2",
        "Crumbs Test 3": "/test/crumbs3",
        "Crumbs Test 4 Long Text Here": "/test/crumbs1/crumbstest2/crumbs4long",
        "Crumbs Test 5 Long Text Here": "/test/crumbs1/crumbstest2/crumbs4long/crumbs5",

    },
    external: {
        // May not be a external link
        // "External Link Disclaimer": "https://www.ahrq.gov/policy/foia/index.html",
        "FOIA": "https://www.ahrq.gov/policy/foia/index.html"
    },
    private: {

        formMockup: "/formMockup",
        cda: "/data/cda",
        displayBatchDetail: "/eventDataSubmission/displayBatchDetail",
        login: "/login",
        activationToken: "/activation/token/:token",
        activationToken2: "/activation/token/:token/2",
        activationToken3: "/activation/token/:token/3",
        token: "/token/:token",
        token2: "/token/:token/2",
        passwordToken: "/password/token/:token",
        passwordToken2: "/password/token/:token/2",
        tabDatatable: "/tabDatatable",
        createOrganization: "/manage/:oT/createOrganization",
        editOrganization: "/manage/:oT/editOrganization",
        viewOrganization: "/manage/:oT/viewOrganization",
        manageOrganization: "/manage/organization",
        manageUser: "/manage/user",
        createUser: "/manage/createUser",
        viewUser: "/manage/viewUser",
        editUser: "/manage/editUser",
        manageDocument: "/manage/document",
        createDocument: "/manage/createDocument",
        viewDocument: "/manage/viewDocument",
        manageTableau: "/manage/tableau",
        createTableauUser: "/manage/tableau/createUser",
        editTableauUser: "/manage/tableau/editUser",
        createTableauReportDefinition: "/manage/tableau/createReportDefinition",
        editTableauReportDefinition: "/manage/tableau/editReportDefinition",
        analyticsDashboard: "/analytics/dashboard",
        analyticsDashboardView: "/analytics/dashboard/view",
        manageProfile: "/manage/profile",
        createPSOProfile: "/manage/createPSOProfile",
        editPSOProfile: "/manage/editPSOProfile",
        carryOverPSOProfile: "/manage/carryOverPSOProfile",
        viewPSOProfile: "/manage/viewPSOProfile",
        helpCenter: "/helpcenter",
        dashboard: "/dashboard",
        manageVendorAuthorization: "/manage/authorization",
        viewVendorAuthorization: "/manage/viewVendorAuthorization",
        addVendorAuthorization: "/manage/addVendorAuthorization",
        editVendorAuthorization: "/manage/editVendorAuthorization",
        wsa: "/manage/wsa",
        editWebServiceAccount: "/manage/editWebServiceAccount",
        webService: "/manage/webservice",
        resetUserPassword: "/manage/resetUserPassword",
        setupMfa: "/manage/setupMfa",
        editUserProfile: "/manage/editUserProfile",
        editUserProfilePicture: "/manage/editUserProfilePicture",
        dataSubmissionAlternate: "/data/alternate",
        alternateBatchDetail: "/eventDataSubmission/altBatchDetail",
        reportComment: "/report/comment",
        analyticReport: "/report/analytic",
        submissionSummaryReport: "/report/submissionSummary",
        submissionReport: "/report/submission",
        resources: "/resources/reference",
        managePSODirectory: "/manage/directory",
        viewPSODirectoryBatchDetail: "/manage/viewBatch"
    }
}

export const PATH_HAS_TITLE = {
    [PATHS.public.Article]: true,
    [PATHS.public["Article With Slug"]]:true
}

export const DEFAULT_TITLE = "PSOPPC";